import { scan_barcode } from '../../../../backbone-unorganized/utils/barcodes';
import { isWeb } from '../../../../shared/utils/is';
import { BaseFieldView } from '../BaseField/views';
import { ReactPageWrapper } from '../../../shared/views/ReactPageWrapper';
import { BarcodeScanner } from '@zenput/feature-zencam';

export const BarcodeFieldView = BaseFieldView.extend({
    events: {
        'change .barcode_value': 'change_barcode_value',
        'click .field_action_btn': 'click_barcode'
    },

    change_barcode_value: function (event) {
        var field_id = $(event.target).attr('field_id');
        var barcode_value = $('#field_' + field_id + ' .barcode_value').val();
        this._update_barcode_value(field_id, barcode_value);
    },

    click_barcode: async function (event) {
        var target = $(event.target);
        var field_id = target.attr('field_id');

        if (isWeb()) {
            this.open_react_barcode_scanner(field_id);
            return false;
        }

        const scan_result = await scan_barcode();

        if (!scan_result) {
            return false;
        }

        this._update_barcode_value(field_id, scan_result);
        return false;
    },

    _update_barcode_value: function (field_id, barcode_value) {
        const this_ = this;
        this_.model.set({ value: barcode_value });
        $('#field_' + field_id + ' .barcode_value').val(barcode_value);
    },

    open_react_barcode_scanner: function (field_id) {
        const this_ = this;
        const onScanSuccess = (scan_result) => {
            this_._update_barcode_value(field_id, scan_result);
        };

        $f.mobile.nav.show_modal(ReactPageWrapper, {
            renderFunction: function () {
                return (
                    <BarcodeScanner
                        onResultCallback={(result) => {
                            if (result != null) {
                                onScanSuccess(result);
                            }
                            this.close();
                        }}
                    />
                );
            }
        });
        return;
    }
});
